import { useId as useReactId } from 'react';

/**
 * Generates a unique id for the component.
 */
export const useId = (id?: string) => {
    const randomId = useReactId();

    return id || randomId;
};
